var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSejlsportRoklub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.335,8.582A.483.483,0,1,0,5.818,8.1.484.484,0,0,0,5.335,8.582Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.259,8.582A.483.483,0,1,0,8.742,8.1.484.484,0,0,0,8.259,8.582Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.671,11.023a.283.283,0,0,0-.035-.034l-.576-.452a.615.615,0,0,0-.119-.065l.385-.867h.007a.228.228,0,0,0-.061-.452l-.2.027-.95.128a.417.417,0,0,0-.293-.121H8.656a.417.417,0,0,0-.417.416v1.244a.454.454,0,0,0,.036.176H7.747a.376.376,0,0,0-.035-.034l-.576-.452a.47.47,0,0,0-.125-.062l.39-.87h.008a.228.228,0,0,0-.061-.452l-.2.027L6.2,9.308A.417.417,0,0,0,5.9,9.187H5.729a.416.416,0,0,0-.416.416v1.244a.454.454,0,0,0,.036.176H2.416a1.34,1.34,0,0,0,1.336,1.336H5.671l-.388.849a.236.236,0,0,0,.017.228.593.593,0,0,0,.416.206.281.281,0,0,0,.221-.093,4.36,4.36,0,0,0,.393-.957.624.624,0,0,0,.016-.233H8.6l-.389.849a.242.242,0,0,0,.017.228.593.593,0,0,0,.416.206.283.283,0,0,0,.222-.093,4.41,4.41,0,0,0,.393-.957.668.668,0,0,0,.016-.233h2.566a1.34,1.34,0,0,0,1.336-1.336Zm-4.095-.571-.268.1.008-.8.767-.1-.348.775A.744.744,0,0,0,6.576,10.452Zm2.924,0-.266.1.009-.8.765-.1-.334.748A.357.357,0,0,0,9.5,10.452Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.717,5.214l2.56,0a.138.138,0,0,0,.142-.154A6.028,6.028,0,0,0,7.513,1.215a.148.148,0,0,0-.233.09l-.7,3.739A.143.143,0,0,0,6.717,5.214Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.352,6.956a.335.335,0,0,0,.288.158h4.64a.336.336,0,0,0,.28-.145l.718-.758A.3.3,0,0,0,11,5.748H5a.305.305,0,0,0-.288.451Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSejlsportRoklub);
export default __webpack_public_path__ + "static/media/SEJLSPORT-ROKLUB.ef54117553fec3a26dc0ec65a6846879.svg";
export { ForwardRef as ReactComponent };